//Pessoa = MembroCAVU
export enum VinculoNome {
    DOCENTE = 'Docente',
    SERVIDOR = 'Servidor',
    ESTUDANTEPOS = 'Estudante da Pós-Graduação',
    ESTUDANTEGRAD = 'Estudante da Graduação',
    RCIVIL = 'Representante da Sociedade Civil Organizada',
    ADVOGADO_OAB = 'Advogado'
}

export interface Vinculo {
    id: string | null;
    nome: string;
}

export default interface Pessoa {
    id: string;
    nome: string;
    vinculo: Vinculo;
    cpf: string;
    email: string | null;
    matricula?: string | null;
    ativo?: boolean;
    emOutraBanca?: boolean;
    telefone?: string;
    isMembroCavu: boolean;
    jaConsultadoMesmoEditalChamada?: boolean;
    jaDefinidoMesmoEditalChamada?: boolean;
}

export interface PessoasDisponibilidadeResponse {
    pessoasParaTitulares: Pessoa[];
    pessoasParaSuplentes: Pessoa[];
    pessoasParaTecnicos: Pessoa[];
    pessoasParaSecretarios: Pessoa[];
}

export class PessoaUtils {

    static vinculoReduzido = (v: VinculoNome): string => {
        switch (v) {
            case VinculoNome.ESTUDANTEGRAD: return 'Graduação'
            case VinculoNome.ESTUDANTEPOS: return 'Pós'
            case VinculoNome.RCIVIL: return 'S. Civil'
            case VinculoNome.DOCENTE: return 'Docente'
            case VinculoNome.SERVIDOR: return 'Servidor'
            case VinculoNome.ADVOGADO_OAB: return 'Advogado'
        }
    }

    static filtrarPessoasPorVinculo(pessoas: Pessoa[], vinculoNome: VinculoNome): Pessoa[] {
        return pessoas.filter(pessoa => pessoa.vinculo.nome === vinculoNome);
    }

    static labelFemininoPapel(papel: string): string {
        switch (papel) {
            case 'Titular':
                return 'Titular';
            case 'Suplente':
                return 'Suplente (Opcional)';
            case 'Técnico':
                return 'Técnico(a)';
            case 'Secretário':
                return 'Secretário(a)';
            case 'Advogado':
                return 'Advogado(a)';
            default:
                return 'Outro';
        }
    };

    static labelFemininoVinculo(vinculo: VinculoNome): string {
        switch (vinculo) {
            case VinculoNome.DOCENTE:
                return 'Docente';
            case VinculoNome.SERVIDOR:
                return 'Servidor(a)';
            case VinculoNome.ESTUDANTEPOS:
                return 'Estudante da Pós-Graduação';
            case VinculoNome.ESTUDANTEGRAD:
                return 'Estudante da Graduação';
            case VinculoNome.RCIVIL:
                return 'Representante da Sociedade Civil Organizada';
            case VinculoNome.ADVOGADO_OAB:
                return 'Advogado(a)';
            default:
                return 'Outro';
        }
    }

}